import React, { useState } from 'react';
import {
    Card,
    Grid,
    Button,
} from '@mui/material';
import { makeStyles } from '@mui/styles';
import clsx from 'clsx';
import { Link } from 'react-router-dom';
import useAuth from 'app/hooks/useAuth';
import LogoAssistaMais from 'app/components/LogoAssistaMais/LogoAssistaMais';
import BotaoArredondado from 'app/components/BotaoArredondado';
import CadastroAnuncianteForm1 from './CadastroAnuncianteForm1';
import CadastroAnuncianteForm2 from './CadastroAnuncianteForm2';
import CadastroAnuncianteForm3 from './CadastroAnuncianteForm3';
import ArrowBack from 'app/components/ArrowBack/ArrowBack';
import CadastroAnuncianteForm4 from './CadastroAnuncianteForm4';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';

const useStyles = makeStyles(({ palette, ...theme }) => ({
    cardHolder: {
        background: '#FFF',
    },
    card: {
        maxWidth: 800,
        borderRadius: 12,
        margin: '1rem',
    },
    titulo: {
        fontSize: '1.5rem',
        fontWeight: 'bold',
        color: 'var(--BlackOne)'
    },
    subtitulo: {
        fontSize: '1rem',
        fontWeight: 'normal',
        color: 'var(--BlackTwo)'
    }
}));

const JwtRegister = () => {
    const [state, setState] = useState({
        cnpj: '',
        inscricaoEstadual: '',
        nomeFantasia: '',
        razaoSocial: '',
        website: '',
        telefoneEmpresa: '',
        endereco: '',
        numero: '',
        complemento: '',
        bairro: '',
        cep: '',
        cidade: '',
        estado: '',
        email: '',
        nomeResponsavel: '',
        sobrenome: '',
        cargo: '',
        cpf: '',
        telefoneResponsavel: '',
        password: ''
    });
    const [estagio, setEstagio] = useState(1);
    const classes = useStyles();
    const { register } = useAuth();

    const handleChange = ({ target: { name, value } }) => {
        setState({
            ...state,
            [name]: value,
        });
    };

    const voltar = () => {
        setEstagio(estagio - 1);
    };

    const handleFormSubmit = async (values) => {
        if (estagio === 3) {
            // Chamar a API de cadastro do usuário
            await register(values.email, values.password);
        }
        if (estagio < 4) {
            setEstagio(estagio + 1);
        }
    };

    const getLabelBotao = () => estagio < 3 ? 'Continuar' : estagio === 3 ? 'Cadastrar' : 'Fechar';

    const validationSchema = Yup.object().shape({
        cnpj: Yup.string().required('Preencha o CNPJ'),
        inscricaoEstadual: Yup.string().required('Preencha a Inscrição Estadual'),
        nomeFantasia: Yup.string().required('Preencha o nome fantasia'),
        razaoSocial: Yup.string().required('Preencha a razão social'),
        website: Yup.string().url('Insira um website válido').required('Preencha o website'),
        telefoneEmpresa: Yup.string().required('Preencha o telefone da empresa'),
        endereco: Yup.string().required('Preencha o endereço'),
        numero: Yup.string().required('Preencha o número'),
        bairro: Yup.string().required('Preencha o bairro'),
        cep: Yup.string().required('Preencha o CEP'),
        cidade: Yup.string().required('Preencha a cidade'),
        estado: Yup.string().required('Selecione o estado'),
        email: Yup.string().email('E-mail inválido').required('Preencha o e-mail'),
        nomeResponsavel: Yup.string().required('Preencha o nome do responsável'),
        cpf: Yup.string().required('Preencha o CPF'),
        telefoneResponsavel: Yup.string().required('Preencha o telefone'),
        password: Yup.string().required('Preencha a senha')
    });

    const getForm = () => {
        switch (estagio) {
            case 1:
                return <CadastroAnuncianteForm1 handleChange={handleChange} {...state} />;
            case 2:
                return <CadastroAnuncianteForm2 handleChange={handleChange} {...state} />;
            case 3:
                return <CadastroAnuncianteForm3 handleChange={handleChange} {...state} />;
            case 4:
                return <CadastroAnuncianteForm4 handleChange={handleChange} {...state} />;
            default:
                return null;
        }
    };

    return (
        <div
            className={clsx(
                'flex items-start justify-center min-h-full-screen pt-5',
                classes.cardHolder
            )}
        >
            <div className={classes.card}>
                <Grid container>
                    <Grid item lg={12} md={12} sm={12} xs={12}>
                        <LogoAssistaMais />
                    </Grid>
                    {estagio !== 4 &&
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                            <div className={classes.titulo}>
                                {estagio !== 1 && <ArrowBack onClick={voltar} className="mr-6" />} Cadastro de Anunciante
                            </div>
                            <div className={clsx('mt-4', classes.subtitulo)}>{estagio === 3 ? 'Dados do Responsável legal da Empresa' : 'Dados da empresa'}</div>
                        </Grid>
                    }

                    <Grid item lg={12} md={12} sm={12} xs={12}>
                        <div className="pt-3 h-full">
                            <Formik
                                initialValues={state}
                                validationSchema={validationSchema}
                                onSubmit={handleFormSubmit}
                            >
                                {({ isSubmitting }) => (
                                    <Form>
                                        {getForm()}

                                        <div className="flex flex-wrap items-end justify-center mb-12 mt-8">
                                            <BotaoArredondado value={getLabelBotao()} disabled={isSubmitting} />
                                        </div>
                                    </Form>
                                )}
                            </Formik>
                        </div>
                    </Grid>
                </Grid>
            </div>
        </div>
    );
};

export default JwtRegister;
